/**
 * Title + back affordance for pushed screens.
 *
 * The back control is a 48px target on the LEFT, which is where a right-handed
 * thumb naturally lands when re-gripping — and it is a real button rather than
 * relying on the browser gesture, because the app runs in `display: standalone`
 * where iOS shows no chrome at all.
 */
import { useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';

export function ScreenHeader({
  title,
  subtitle,
  action,
  backTo,
}: {
  readonly title: string;
  readonly subtitle?: string;
  readonly action?: ReactNode;
  /** Explicit destination; defaults to browser back. */
  readonly backTo?: string;
}): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="mb-4 flex items-center gap-2">
      <button
        type="button"
        onClick={() => (backTo === undefined ? navigate(-1) : navigate(backTo))}
        aria-label="Quay lại"
        className="tap shrink-0 rounded-full text-slate-600 active:bg-slate-200"
      >
        <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="m14 6-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-xl font-bold text-slate-900">{title}</h1>
        {subtitle === undefined ? null : <p className="truncate text-sm text-slate-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
